import Icon from 'components/shared/Icon/Icon';
import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

import { normalizeErrorMessage } from './components/PayFromKioskModal/lib/paymentMessages';

const ErrorPayment = ({ message, description, title, onTryAgain, onClose, isOpen = true }) => {
  const errorLines = normalizeErrorMessage(message);

  return (
    <Modal
      isOpen={isOpen}
      handleClose={onClose}
      isCentered
      overlayClassName="!z-[200]"
      customHeader={
        <Typography variant="p" size="large" weight="semibold">
          {title || 'Payment failed'}
        </Typography>
      }
      footer={
        <div className="flex flex-row flex-wrap content-center items-center justify-center gap-3">
          <Button
            text="Close"
            style="outlined"
            color="neutral"
            shade={700}
            size="medium"
            onClick={onClose}
          />
          <Button text="Try again" size="medium" onClick={onTryAgain} />
        </div>
      }
      bodyClassName="bg-white pt-4 pb-6">
      <div className="mx-auto flex h-full max-w-[366px] flex-col items-center justify-center gap-3">
        <Icon icon="illustration-payment-failed" />
        <div className="flex flex-col items-center gap-1 text-center">
          {errorLines.map((line) => (
            <Typography key={line} variant="p" size="medium" weight="medium">
              {line}
            </Typography>
          ))}
          <Typography variant="p" color="neutral-600" size="medium">
            {description ||
              "We couldn't process your payment. Please check your card or try again with a different method."}
          </Typography>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorPayment;
